export const Menu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path d="M10 11.6667H30V15H10V11.6667Z" fill="white" />
      <path d="M10 18.3333H30V21.6667H10V18.3333Z" fill="white" />
      <path d="M10 25H30V28.3333H10V25Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 11.6667H10V15H30V11.6667ZM30 18.3333H10V21.6667H30V18.3333ZM30 25H10V28.3333H30V25Z"
        fill="white"
      />
    </svg>
  );
};
